import React from 'react';

import { Container } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

import { Navigation } from './Navigation';
import { DesktopSideNavbar } from './Navigation/DesktopSideNavbar';
import { MobileNavigation } from './Navigation/MobileNavigation';

const Layout: React.FC = () => {
  return (
    <>
      <Container
        h='auto'
        maxW='600px'
        minH='100vh'
        pb='24px'
        position='relative'
        pt={0}
        px={0}
      >
        <DesktopSideNavbar />
        <MobileNavigation />
        <Navigation />
        <Outlet />
      </Container>
    </>
  );
};

export default Layout;
